<template>
  <div class="current_page" :class="{ noEbooks: noItemsAvailable }">
    <section v-show="!noItemsAvailable">
      <div class="container adjusted-container-width">
        <h1 class="itemListTitle">{{ t("ebook_title") }}</h1>
        <div class="ebooks-wrapper" :class="{ oddItems: odd }"
             v-infinite-scroll="loadItemsBatch" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
          <CardEbooks
            v-for="ebookItem in displayedItems"
            :key="ebookItem.friendly_url"
            :item="ebookItem"
          />
        </div>
      </div>
    </section>
    <available-soon
      :noItemsAvailable="noItemsAvailable"
      itemType="ebooks"
    ></available-soon>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import CardEbooks from "../../../components/itemCard/CardEbooks";
import availableSoon from "@/views/plus/itemList/sharedComponents/noAvailableItems";

import Vue from 'vue';

import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)

export default {
  name: "EBooks",
  components: { CardEbooks, availableSoon },
  props: ["symbol"],
  data() {
    return {
      displayedItems: []
    };
  },
  computed: {
    ...mapState("ebooks", ["ebooks"]),
    ...mapGetters(["t"]),
    noItemsAvailable: function() {
      return Array.isArray(this.ebooks) && this.ebooks.length == 0;
    },
    odd: function() {
      if (!(this.displayedItems === undefined || this.displayedItems.length == 0)) { //todo: check if can remove the condition of undefined
        return this.displayedItems.length % 2 != 0;
      }
      return false;
    }
  },
  methods: {
    ...mapMutations(["hideComponentMountLoader"]),
    ...mapActions(["getInfoFromWebsite"]),
    ...mapActions("ebooks", ["getEbooks"]),
    loadItemsBatch: function(){
      const displayedAmount = this.displayedItems.length;
      let additionalAmount = window.matchMedia("(max-width: 768px)").matches
          ? 3
          : 6;
      this.displayedItems = this.ebooks.slice(0, displayedAmount+additionalAmount);
    },
  },
  created() {
    this.getEbooks(this.symbol).then(() =>{this.loadItemsBatch();});
    this.getInfoFromWebsite("symbols"); //for the related assets images
  },
  mounted() {
    this.hideComponentMountLoader();
  }
};
</script>

<style lang="scss" scoped>
.noEbooks.current_page {
  padding: 0;
}
.current_page {
  .container {
    padding-right: 0px;
    padding-left: 0px;
    @media (max-width: 768px) {
      max-width: 20.5rem;
    }
    h1 {
      margin-left: 15px;
      margin-bottom: 1.5rem;
      font-size: 1.75rem;
      @media only screen and (max-width: 767px) {
        font-size: 1.25rem;
        margin-left: 0;
      }
    }
  }
}

.ebooks-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  &.oddItems:after {
    content: "";
    flex: auto;
    max-width: 47.4%;
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .current_page {
    padding: 1.5rem 1rem 0;
  }
}
</style>
